module.exports = __webpack_public_path__ + "static/about-us-b10d7c4e411f7fc8e95442ed132cd591.svg";